/* eslint-disable */
import { Project, Person } from '../index';

declare var Object: any;
export interface PersonProjectInterface {
  id: string;
  projectId?: string;
  personId?: string;
  project?: Project;
  person?: Person;
}

export class PersonProject implements PersonProjectInterface {
  'id': string = '';
  'projectId': string = '';
  'personId': string = '';
  project: Project = null;
  person: Person = null;
  constructor(data?: PersonProjectInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PersonProject`.
   */
  public static getModelName() {
    return 'PersonProject';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of PersonProject for dynamic purposes.
   **/
  public static factory(data: PersonProjectInterface): PersonProject {
    return new PersonProject(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'PersonProject',
      plural: 'PersonProjects',
      path: 'person-projects',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        projectId: {
          name: 'projectId',
          type: 'string',
        },
        personId: {
          name: 'personId',
          type: 'string',
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
          keyFrom: 'projectId',
          keyTo: 'id',
        },
        person: {
          name: 'person',
          type: 'Person',
          model: 'Person',
          relationType: 'belongsTo',
          keyFrom: 'personId',
          keyTo: 'id',
        },
      },
    };
  }
}
